/**
 * The colour the next sticky note is placed in, persisted in
 * `sessionStorage` (ahooks) like the shape and pen styles. The bar's Sticky
 * tile wears it, the Sticky tray sets it, and placement reads it.
 */

import { useSessionStorageState } from "ahooks";
import {
  DEFAULT_NOTE_COLOR,
  NOTE_COLORS,
} from "../nodes/shared/CanvasColorPalettes";

export type NoteStyleState = { color: string };

export const DEFAULT_NOTE_STYLE: NoteStyleState = { color: DEFAULT_NOTE_COLOR };

const NOTE_STYLE_KEY = "canvas:noteStyle";

function deserializeNoteStyle(raw: string): NoteStyleState {
  try {
    const parsed = JSON.parse(raw) as Partial<NoteStyleState>;
    const known = NOTE_COLORS.some((c) => c.value === parsed.color);
    return { color: known && parsed.color ? parsed.color : DEFAULT_NOTE_COLOR };
  } catch {
    return DEFAULT_NOTE_STYLE;
  }
}

export function useCanvasNoteStyle() {
  const [noteStyle, setNoteStyle] = useSessionStorageState<NoteStyleState>(
    NOTE_STYLE_KEY,
    {
      defaultValue: DEFAULT_NOTE_STYLE,
      deserializer: deserializeNoteStyle,
      listenStorageChange: true,
    },
  );
  const style = noteStyle ?? DEFAULT_NOTE_STYLE;
  return {
    noteColor: style.color,
    setNoteColor: (color: string) => setNoteStyle({ color }),
  };
}
